import React from 'react'
import { HashLink } from 'react-router-hash-link'
import styled from 'styled-components'

const FixFoot = () => {
    const hash = window.location.hash
    const host = window.location.hostname.split('.')[0]
    const firstPathname = window.location.pathname.split('/')[1]

    const onClickTop = () => {
        window.scrollTo(0, 0)
    }

    return (
        <>
            {/*22-08-22 카트에서 fix_foot을 노출하기 위해
            <link rel="stylesheet" href="<%=process.env.REACT_APP_CDN_JS%>/_v5/css/mobile/common.css" />--> 추가시 CSS 충돌이 발생
            이를 피하기 위해 styled-components로 fix_foot 아이콘 이미지 불러오기로 전환
            */}

            <Style className="header_component_fix_foot" host={host}>
                {/*<Alink href={process.env.REACT_APP_WWW_URL} size={23}><i className="icon-ic_home" />홈</Alink>*/}
                <Alink href={process.env.REACT_APP_WWW_URL} size={23}> <IconHome/>홈</Alink>
                <HLink to={`${hash === '#aside' ? '#' : '#aside'}`} size={17}> <IconHam/>상품분류</HLink>
                <Alink href={`${process.env.REACT_APP_SEARCH_URL}`} size={23}><IconSearch/>검색</Alink>
                <Alink href={`//my2.pping.${process.env.REACT_APP_TLD}`} size={23}><IconMyshopping/>마이쇼핑</Alink>
                <Alink href={process.env.REACT_APP_HELP_URL} size={24}><IconCall/>고객센터</Alink>
            </Style>
            {(host === 'm' || (host === 'shopping' && firstPathname === 'list') || 'stdpc') && (
                <GoTop onClick={onClickTop} className="header_component_go_to_top" host={host}/>
            )}
        </>
    )
}

const Style = styled.div`
    position: fixed;
    bottom: 0px;
    ${props => props.host === 'cart' || props.host === 'order' ? null:'max-width:720px;'};//cart에서 가로모드로 보면 720px 이상에서는 다 깨지기 때문
    width: 100%;
    display: flex;
    height: 65px;
    z-index: 910;
    border-top: 1px solid #aaa;
    background: rgb(255, 255, 255);
    padding: 7px 0px;
    box-sizing: border-box;
`
const Alink = styled.a`
    height: 49px;
    width: 20%;
    line-height: 17px;
    text-align: center;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    i {
        display: flex;
        height: 24px;
        align-items: center;
        justify-content: center;
        font-size: ${props => props.size}px;
    }
`
const HLink = styled(HashLink)`
    height: 49px;
    width: 20%;
    line-height: 17px;
    text-align: center;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    i {
        display: flex;
        height: 24px;
        align-items: center;
        justify-content: center;
        font-size: ${props => props.size}px;
    }
`
const GoTop = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 14px;
    bottom: 80px;
    width: 40px;
    height: 40px;
    border: 1px solid #ccc;
    background: rgba(255, 255, 255, 0.8);
    font-size: 20px;
    color: #777;
    z-index: 910;

    &:before {
        font-family: 'ppingkr_v4';
        content: "\\ea28"
    }

    @media screen and (min-width: 720px) {
        ${props => props.host === 'order'
            ? `right: 10px`
            : `right: calc(50% - 344px)`
        }//order에서 화면을 넓혔을 때 탑 버튼이 화면 중앙 정도의 위치로 이동하기 때문에 우측으로 붙임
    }
`

const IconHome = styled.i`
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.size}px;
    font-style: normal;

    &:before{
    font-family: 'ppingkr_v4';
    content: "\\ea23"
    }
`

const IconHam = styled.i`
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.size}px;
    font-style: normal;

    &:before{
    font-family: 'ppingkr_v4';
    content: "\\ea2d"
    }
`

const IconSearch = styled.i`
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.size}px;
    font-style: normal;

    &:before{
    font-family: 'ppingkr_v4';
    content: "\\ea29"
    }
`

const IconMyshopping = styled.i`
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.size}px;
    font-style: normal;

    &:before{
    font-family: 'ppingkr_v4';
    content: "\\ea25"
    }
`
const IconCall = styled.i`
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.size}px;
    font-style: normal;

    &:before{
    font-family: 'ppingkr_v4';
    content: "\\ea2b"
    }
`



export default FixFoot



// WEBPACK FOOTER //
// ./src/m_header/components/fix_foot/index.js